import { render, staticRenderFns } from "./addResources.vue?vue&type=template&id=ea476b96&scoped=true"
import script from "./addResources.vue?vue&type=script&lang=js"
export * from "./addResources.vue?vue&type=script&lang=js"
import style0 from "./addResources.vue?vue&type=style&index=0&id=ea476b96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_vue-template-compiler@2.7.15_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea476b96",
  null
  
)

export default component.exports